// GSLA APIs
export const GET_GSLA_FOR_WAREHOUSE = '/getGSLAForWarehouse';
export const GET_GSLA_FOR_MULTIPLE_WAREHOUSES = '/getGSLA';
export const GET_GSLA_RECOMMENDATIONS_FOR_WAREHOUSE = '/getGSLARecommendationForWarehouse';
export const GET_GSLA_RECOMMENDATIONS_FOR_MULTIPLE_WAREHOUSE = '/getGSLARecommendations';
export const PUBLISH_GSLA_FOR_WAREHOUSE = '/publishGSLA';
export const DELETE_GSLA = '/deleteGSLA';
export const GET_FC_METADATA = '/getFCMetadata';

// R2F Threshold APIs
export const GET_R2F_THRESHOLDS = '/getR2FThresholds';
export const GET_R2F_THRESHOLDS_FOR_WAREHOUSE = '/getR2FThresholdsForWarehouse';
export const GET_ENTIRE_NETWORK_R2F_THRESHOLDS = '/getEntireNetworkR2FThresholds';
export const PUBLISH_R2F_THRESHOLDS = '/publishR2FThresholds';
export const DELETE_R2F_THRESHOLDS = '/deleteR2FThresholds';

// Production Capability APIs
export const GET_PC_FOR_WAREHOUSE_LIST = '/getPCForWarehouseList';
export const GET_PC_DETAILS_FOR_WAREHOUSE = '/getPCDetailsForWarehouse';

// Backend APIs
export const GET_USER_PERMISSIONS = '/getUserPermissions';

// CORA APIs
export const GET_CORA_DATA = '/getFCCORAData';
export const AFTX_GET_FC_CORA_DATA = '/aftxGetFCCORAData';

// FC Config APIs
export const GET_FC_CONFIG = '/getFCConfig';
export const UPDATE_FC_CONFIG = '/updateFCConfig';
export const TRIGGER_CATEGORIZATION_GENERATION = '/triggerCategorizationGeneration';
export const UPDATE_PC_OVERRIDES = '/updatePCOverrides';
export const DELETE_PC_OVERRIDE = '/deletePCOverride';

// Shipment History APIs
export const GET_HISTORY_FOR_SHIPMENT = '/getHistoryForShipment';
